import { render, staticRenderFns } from "./ProblemSymptoms.vue?vue&type=template&id=1a31258d&scoped=true&"
import script from "./ProblemSymptoms.vue?vue&type=script&lang=js&"
export * from "./ProblemSymptoms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a31258d",
  null
  
)

export default component.exports